import PropTypes from 'prop-types';
import {
    LoaderMi,
    FieldsetControl,
    RadioControl,
    ModalV2,
    ModalV2Title,
    ModalV2Content,
    ModalV2Footer,
    Button,
    ButtonGroup,
} from '@si-armes/dsfr-react';
import React, { useEffect, useRef } from 'react';
import { useForm } from 'react-hook-form';

const ModalBan = ({ residence, isLoading, data, fermerModal, remplacer, conserver }) => {
    const { register, watch, setValue } = useForm({
        mode: 'onChange',
    });

    useEffect(() => {
        setValue('choixBan', 'conserver');
    });

    const typeResidence = () => {
        if (residence === 'principale') {
            return 'résidence principale';
        }
        if (residence === 'secondaire') {
            return 'résidence secondaire';
        }
        return null;
    };

    const continuer = () => {
        if (watch('choixBan') === 'remplacer') {
            remplacer();
        } else {
            conserver();
        }
    };

    const dialog = useRef();

    useEffect(() => {
        if (dialog.current) {
            dialog.current.showModal();
        }
    }, [dialog]);

    return (
        <>
            {isLoading && <LoaderMi taille="lg" />}
            {!isLoading && (
                <ModalV2
                    id="notification"
                    idModalTitle="notification-title"
                    onClose={fermerModal}
                    size="lg"
                    ref={dialog}
                >
                    <ModalV2Content>
                        <ModalV2Title id="notification-title">Notification</ModalV2Title>
                        {data ? (
                            <>
                                <p>
                                    L&apos;adresse renseignée pour la {typeResidence()} correspond
                                    au résultat suivant dans la base nationale des adresses :
                                </p>
                                <div className="choix-actions-adresse">
                                    <FieldsetControl
                                        id="choixBanForm"
                                        legend="Souhaitez-vous conserver votre adresse ou la remplacer par celle ci-dessus ?"
                                    >
                                        <RadioControl
                                            id="choixBan-conserver"
                                            label="Conserver"
                                            value="conserver"
                                            taille="sm"
                                            {...register('choixBan')}
                                        />
                                        <RadioControl
                                            id="choixBan-remplacer"
                                            label="Remplacer"
                                            value="remplacer"
                                            taille="sm"
                                            {...register('choixBan')}
                                        />
                                    </FieldsetControl>
                                </div>
                            </>
                        ) : (
                            <>
                                <p>
                                    Votre adresse n&apos;a pas été trouvée dans la base nationale
                                    des adresses.
                                </p>
                                <p>
                                    Cliquez sur &quot;continuer&quot; pour conserver votre adresse
                                    ou sur &quot;annuler&quot; afin de la modifier
                                </p>
                            </>
                        )}
                    </ModalV2Content>
                    <ModalV2Footer>
                        <ButtonGroup inline align="right">
                            <Button name="Annuler" variant="secondary" onClick={fermerModal}>
                                Annuler
                            </Button>
                            <Button name="Continuer" variant="primary" onClick={continuer}>
                                Continuer
                            </Button>
                        </ButtonGroup>
                    </ModalV2Footer>
                </ModalV2>
            )}
        </>
    );
};

ModalBan.propTypes = {
    residence: PropTypes.string.isRequired,
    fermerModal: PropTypes.func.isRequired,
    isLoading: PropTypes.bool,
    data: PropTypes.any,
    remplacer: PropTypes.func.isRequired,
    conserver: PropTypes.func.isRequired,
};

export default ModalBan;
